import { AccountSettingsPageQueryParams, AccountSettingsPageTab } from '../types/AccountSettings.types';
import { parseQueryParams } from '@/utils/queryParams';
import { useLocation } from 'react-router-dom';

const useAccountSettingsPageTab = (): AccountSettingsPageTab => {
    const location = useLocation();
    const queryParams = parseQueryParams<AccountSettingsPageQueryParams>(location.search);

    if (queryParams?.tab === AccountSettingsPageTab.Preferences) {
        return AccountSettingsPageTab.Preferences;
    } else if (queryParams?.tab === AccountSettingsPageTab.Profile) {
        return AccountSettingsPageTab.Profile;
    } else if (queryParams?.tab === AccountSettingsPageTab.TaxCertManagement) {
        return AccountSettingsPageTab.TaxCertManagement;
    }

    return AccountSettingsPageTab.Profile;
};

export default useAccountSettingsPageTab;
